
import { mapActions, mapMutations } from "vuex";
import api from "@/services/api"; // base já deve estar em /api via env.js + axios

export default {
  data: () => ({
    username: "",
    password: "",
    loading: false,
    snackbar: false,
    snackbarMessage: "",
  }),

  mounted() {
    // limpa o estado do usuário ao abrir a tela
    this.setUsuarioState({
      id: "",
      nome: "",
      token: "",
      avatar: "",
      nome_unidade: "",
      id_unidade: "",
    });

    // zera token persistido para evitar redirecionamento automático
    try {
      localStorage.removeItem("token");
    } catch (e) {
      console.debug("localStorage.removeItem falhou:", e);
    }
  },

  methods: {
    // navigation: mutation correta recebe um ARRAY, não objeto espalhado
    ...mapMutations("navigation", { setNavItems: "setNavigationItems" }),

    // usuario: alias para não colidir
    ...mapMutations("usuario", { setUsuarioState: "setUsuario" }),

    // deixei disponível caso usem em outro fluxo
    ...mapActions("usuario", ["logIn"]),

    login() {
      if (this.loading || !this.username || !this.password) return;
      this.loading = true;

      api
        .post(`/login-vendas`, {
          username: this.username,
          password: this.password,
        })
        .then((res) => {
          const data = {
            id: res.data.id,
            nome: res.data.user,
            token: res.data.token,
            avatar: res.data.avatar,
            nome_unidade: res.data.nome_unidade,
            id_unidade: res.data.id_unidade,
          };

          this.setUsuarioState(data);
          // IMPORTANTE: envia o array direto
          this.setNavItems(res.data.navigation);

          this.loading = false;
          this.$router.push({ path: "/" });
        })
        .catch((err) => {
          this.loading = false;
          this.snackbar = true;

          // tenta extrair mensagem útil do backend
          const msg =
            (err &&
              err.response &&
              (err.response.data?.message || err.response.data)) ||
            "";
          const status = (err && err.response && err.response.status) || "";

          this.snackbarMessage = msg
            ? String(msg)
            : `Ocorreu um erro ao fazer o login.${status ? " (HTTP " + status + ")" : ""}`;
        });
    },
  },
};
